export default "__VITE_ASSET__7c1b585e__"